// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"72":"0b7b90cd","125":"component---src-pages-404-js","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"72":"cb72ee9451545f11d5e7","125":"1941b70ca807faba4116","245":"2b755419dd1009e44167","594":"808aad4673c7acd0aa4c"}[chunkId] + ".js";
};